import {makeAutoObservable} from "mobx";

class MobxStore {
    currentUser = void 0;
    token = null;
    test='test xxx';
    navBar = true;
    showSurvey = null;


    constructor() {
        makeAutoObservable(this);
    }

    setShowSurvey(id){
        this.showSurvey=id;
    }

    setCurrentUser(user){
        this.currentUser=user;
    }

    logout(){
        localStorage.removeItem('token');
        this.currentUser=null;
    }

    setToken(strJWT){
        localStorage.setItem('token',strJWT);
    }
    getToken(){
        localStorage.getItem('token');
    }
}



export default new MobxStore();
